import { useEffect, useMemo, useState } from 'react';
/**
 * Client-side pagination for `StarjackTable`. Slices `items` into the current
 * page and resets to the first page whenever `items` changes (e.g. a new
 * search/filter result).
 */
export const usePagination = ({ items = [], itemsPerPage, }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [currentItemsPerPage, setCurrentItemsPerPage] = useState(itemsPerPage || 10);
    const currentItems = useMemo(() => {
        return items?.length
            ? items.slice(currentPage * currentItemsPerPage, currentPage * currentItemsPerPage + currentItemsPerPage)
            : [];
    }, [currentPage, items, currentItemsPerPage]);
    // Reset to the first page only when the dataset changes. `currentPage` must
    // NOT be a dependency here — including it makes every page change re-run the
    // effect and snap back to page 0 (the original pagination bug).
    useEffect(() => {
        setCurrentPage(0);
    }, [items]);
    return {
        currentItems,
        setNextPage: setCurrentPage,
        page: currentPage,
        setItemsPerPage: setCurrentItemsPerPage,
        itemsPerPage: currentItemsPerPage,
        countTotal: items.length,
    };
};
